import { all } from "redux-saga/effects";
import maintenanceSaga from "./maintenance/maintenanceSaga";

export default function* rootSaga() {
  yield all([...maintenanceSaga]);
}
